import React from "react";
import { FilterSection } from "@/components/ui";

export const ReceivedAmountControlPanel = ({
  search, setSearch,
  filters, setFilters,
  sortBy, setSortBy,
  view, setView,
  onAddClick,
  categories,
  showStats,
  setShowStats,
  addLabel,
  onExport,
  isExporting
}) => {
  return (
    <FilterSection
      search={search}
      setSearch={setSearch}
      filters={filters}
      setFilters={(key, value) => setFilters(prev => ({ ...prev, [key]: value }))}
      // viewStyle={view}
      // setViewStyle={setView}
      onAddClick={onAddClick}
      addLabel={addLabel || "Received Amount"}
      onExport={onExport}
      isExporting={isExporting}
      // showDetails={showStats}
      // setShowDetails={setShowStats}
      statusOptions={[
        { value: "pending", label: "Pending" },
        { value: "approved", label: "Approved" },
        { value: "partially_approved", label: "Partially Approved" },
        { value: "paid", label: "Paid" },
        { value: "rejected", label: "Rejected" },
        { value: "cancelled", label: "Cancelled" }
      ]}
      statusPlaceholder="All Statuses"
      // customActions={
      //   <div className="bg-slate-50/50 p-1 rounded-md border border-slate-200/60 shrink-0">
      //     <select
      //       className="text-[13px] font-medium bg-white border border-slate-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-brand-blue text-slate-600 w-36"
      //       value={filters.category || "all"}
      //       onChange={e => setFilters(prev => ({ ...prev, category: e.target.value }))}
      //     >
      //       <option value="all">All Categories</option>
      //       {categories?.map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
      //     </select>
      //   </div>
      // }
    />
  );
};
